export default "__VITE_ASSET__f12W4HM4__"